<template>
	<div style="padding: 0px;">
		<el-form :inline="false" :model="sysuserinfo" :rules="rules" ref="sysuserrule" label-width="120px" class="">
			<el-row>
				<el-col :span="8">
					<el-form-item label="账号名" prop="username">
						<el-input clearable :disabled="!editok" v-model="sysuserinfo.username" maxlength="30"></el-input>
					</el-form-item>
				</el-col>
				<el-col :span="8">
					<el-form-item label="真实姓名" prop="realname">
						<el-input clearable :disabled="!editok" v-model="sysuserinfo.realname" maxlength="30"></el-input>
					</el-form-item>
				</el-col>
				<el-col :span="8">
					<el-form-item label="所属组织" prop="org">
						<el-cascader style="width: 100%;" :disabled="!editok" v-model="userorgid" :options="allOrgTree" :props="orgtreePro"  clearable></el-cascader>
					</el-form-item>
				</el-col>
			</el-row>
			<el-row >
				<el-col :span="8">
					<el-form-item label="联系电话" prop="telphone" >
						<el-input :disabled="!editok" v-model="sysuserinfo.telphone" ></el-input>
					</el-form-item>
				</el-col>
				<el-col :span="8">
					<el-form-item label="过期时间" prop="expirationdate" >
						<el-input :disabled="!editok" v-model="sysuserinfo.expirationdate" ></el-input>
					</el-form-item>
				</el-col>
				<el-col :span="8">
					<el-form-item label="登录类型" prop="type">
						<el-select multiple style="width: 100%;" :disabled="!editok" v-model="sysuserinfo.types" placeholder="请选择类型">
							<el-option v-for="item in typelist" :key="item.code" :label="item.name" :value="item.code"> </el-option>
						</el-select>
					</el-form-item>
				</el-col>
			</el-row>
			<el-row>
				<el-col :span="8">
					<el-form-item label="状态" prop="state" >
						<el-select style="width: 100%;" :disabled="!editok" v-model="sysuserinfo.state" placeholder="请选择状态">
							<el-option v-for="item in statelist" :key="item.code" :label="item.name" :value="item.code"> </el-option>
						</el-select>
					</el-form-item>
				</el-col>
				<el-col :span="16">
					<el-form-item label="角色" prop="role">
						<el-select multiple style="width: 100%;" :disabled="!editok" v-model="sysuserinfo.role" placeholder="请选择角色">
							<el-option v-for="item in rolelist" :key="item.id" :label="item.name" :value="item.id"> </el-option>
						</el-select>
					</el-form-item>
				</el-col>
			</el-row>
		</el-form>
		<!-- <div style="text-align: center;">
			<el-button v-show="!editok" type="primary" @click="editok = true">修改</el-button>
			<el-button v-show="editok" plain @click="closeDlg">取消</el-button>
			<el-button v-show="editok" type="primary" @click="saveSysUser">保存</el-button>
		</div> -->
		
	</div>
</template>

<script> 
	import { queryUserRoles, queryAllSysRoles } from '/static/apiUrl.js'
	export default {
		name : 'UserDetail',
		data() {
			return {
				editok: false,
				disabled_cord: false,
				sysuserinfo : {
					id: "",
					username: "",
					realname : '',
					org: "",
					type: "",
					types : [],
					state : '',
					userpwd : '',
					telphone : '',
					expirationdate : '',
					role : []
				},
				typelist : [
					{
						code : 'web',
						name : '网页端'
					},
					{
						code : 'wechat',
						name : '小程序'
					}
				],
				statelist : [
					{
						code : 'stop',
						name : '停用'
					},
					{
						code : 'normal',
						name : '正常'
					}
				],
				rolelist : [],
				rules:{
					name: [
						{ required: true, message: '请输入名称', trigger: 'blur' }
					],
					orgid: [
						{ required: true, message: '请选择校区', trigger: 'blur' }
					],
					type: [
						{ required: true, message: '请选择类型', trigger: 'blur' }
					],
				},
				orgtreePro : {
					checkStrictly: true,
					value : "id",
					label : "name",
					children : "children"
				},
				userorgid : '',
			}
		},
		mounted() {
			
		},
		BeforeCreate(){
			
		},
		props: {
			selecteduser: {
				type: Object,
				required: false
			},
			allOrgTree : {
				type : Array,
				required: true
			},
			add : {
				type : Boolean,
				required : false,
				default : false,
			}
		},
		watch: {
			add : {
				immediate: true,
				handler(newVal) {
					if(newVal == true){
						this.editok = true
					}else{
						this.editok = false
					}
				}
			},
			allOrgTree : {
				immediate: true,
				handler(newVal) {
					console.log(newVal)
					this.initData()
				}
			},
			selecteduser: {
				immediate: true,
				handler(newVal) {
					if(newVal != null){
						this.sysuserinfo.id = newVal.id
						this.sysuserinfo.name= newVal.name
						this.sysuserinfo.username= newVal.username
						this.sysuserinfo.realname = newVal.realname
						this.sysuserinfo.org= newVal.org
						this.userorgid = newVal.org
						this.sysuserinfo.type= newVal.type
						this.sysuserinfo.types = newVal.type.split(',')
						this.sysuserinfo.state = newVal.state
						this.sysuserinfo.userpwd = newVal.userpwd
						this.sysuserinfo.telphone = newVal.telphone
						this.sysuserinfo.expirationdate = newVal.expirationdates
						this.sysuserinfo.role = []
						this.initUserRole()
					}else{
						this.sysuserinfo.id = ""
						this.sysuserinfo.name=""
						this.sysuserinfo.username= ""
						this.sysuserinfo.realname = ''
						this.sysuserinfo.org= ""
						this.sysuserinfo.type= ""
						this.sysuserinfo.state = ''
						this.sysuserinfo.userpwd = ''
						this.sysuserinfo.telphone = ''
						this.sysuserinfo.expirationdate = ''
						this.sysuserinfo.role = []
						this.sysuserinfo.types = []
					}
				}
			},
		},
		methods: {
			initData(){
				this.rolelist = []
				queryAllSysRoles().then(res => {
					if(0 == res.code){
						this.rolelist = res.datas
					}
				})
			},
			initUserRole(){
				this.sysuserinfo.role = []
				queryUserRoles({uid : this.sysuserinfo.id}).then(res => {
					if(0 == res.code){
						res.datas.forEach((r) => {
							this.sysuserinfo.role.push(r.roleid)
						})
					}
				})
			},
			closeDlg() {
				this.editok = false
				if(this.add){
					this.$emit("needRefrash",false,false)
				}
			},
			saveSysUser(){
				this.$refs["sysuserrule"].validate((valid) => {
					if (valid) {
						let checkok = false
						if(!checkok){
							this.$message({
								showClose: true,
								message: "请完善数据信息",
								type: 'warning'
							});
						}else{
							if(this.sysuserinfo.id != null && this.sysuserinfo.id != ''){  //编辑
								/* editControlPointSet(this.sysuserinfo).then(res => {
									if(0 == res.code){
										this.$message({
											showClose: true,
											message: "添加成功",
											type: 'success'
										});
										this.$emit("needRefrash",true,false)
									}else{
										this.$message({
											showClose: true,
											message: res.message,
											type: 'error'
										});
									}
								}) */
							}else{ //新增
								/* addControlPointSet(this.sysuserinfo).then(res => {
									if(0 == res.code){
										this.$message({
											showClose: true,
											message: "修改成功",
											type: 'success'
										});
										this.$emit("needRefrash",true,false)
									}else{
										this.$message({
											showClose: true,
											message: res.message,
											type: 'error'
										});
									}
								}) */
							}
						}
					} else {
						return false;
					}
				});
			},
		},
		beforeDestroy() {
			
		},
	}
</script>

<style scoped>
	
</style>